import clsx from 'clsx'
import useTranslation from 'next-translate/useTranslation'

import { checkoutCurrentCheckoutDetailsSelector } from '../store/checkoutSelectors'
import useAppSelector from '../../../store/hooks/useAppSelector'
import useCartDrawerOpen from '../hooks/useCartDrawerOpen'
import PreOrderShoppingCart from '../../preOrder/components/PreOrderShoppingCart'
import { preOrderCheckoutSelector } from '../../preOrder/store/preOrderSelectors'
import { CartDrawerId } from '../constants'

import ShoppingCart from './shoppingCart/ShoppingCart'
import styles from './CartDrawer.module.scss'

export default function CartDrawer() {
  const { t } = useTranslation('common')

  const isCartDrawerVisible = useCartDrawerOpen()

  const checkout = useAppSelector(checkoutCurrentCheckoutDetailsSelector)
  const preOrderCheckout = useAppSelector(preOrderCheckoutSelector)

  // If there is no any checkout, then don't render anything
  if (!checkout && !preOrderCheckout) return null

  const isPreOrderCheckout = !!preOrderCheckout

  return (
    // Focusable, so focus can move here when the cart rail opens it
    <aside
      id={CartDrawerId}
      tabIndex={-1}
      aria-label={t('cart.cartAria')}
      className={clsx(styles.container, {
        [styles.isOpen]: isCartDrawerVisible,
      })}
    >
      {isPreOrderCheckout ? <PreOrderShoppingCart /> : <ShoppingCart />}
    </aside>
  )
}
